import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AccessRightFiltersComponent as AccessRightFiltersComponentBase } from '@fi-shared/access-right-filters';
import { takeUntil } from 'rxjs/operators';
import { IFiCheckboxItem } from '@fi-shared/fi-checkbox2/fi-checkbox2';

@Component({
    selector: 'fi-request-access-setting-access-right-filters',
    templateUrl: './access-right-filters.component.html',
    styleUrls: ['./fi-request-access-setting-access-right-filters.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-request-access-setting-access-right-filters' },
    standalone: false,
})
export class RequestAccessSettingsAccessRightFiltersComponent
    extends AccessRightFiltersComponentBase
    implements OnInit
{
    protected rolesListData: IFiCheckboxItem;

    ngOnInit() {
        super.ngOnInit();

        this.onInitialized$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            const roles = this.availableAccessRightFilterCollection.AccessRightCoreFilter.Roles;
            const rolesOutOfScope = this.fiAccessRightHelperService.getOutOfScopeItems(
                roles,
                this.ngModel.AccessRightCoreFilter.Roles,
            );
            this.rolesListData = this.fiAccessRightHelperService.getLightWeightItemCheckboxListData(
                roles,
                rolesOutOfScope,
                this.appTextService.get('common.roles'),
            );
        });
    }
}
